import {
  Flex,
  Stack,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import SmartTooltip from '../../Report/SmartTooltip';

/**
 * Renders the per-mail fields in the Details column of the audit log,
 * falling back to the raw message when an entry has none
 */
export const AuditMailDetails = ({ logItem }: { logItem: any }) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const fields = [
    { key: 'headerFrom', label: t('log.fields.headerFrom') },
    { key: 'recipient', label: t('log.fields.recipient') },
    { key: 'subject', label: t('log.fields.subject') },
    { key: 'messageId', label: t('log.fields.messageId') },
    { key: 'mailbox', label: t('log.fields.mailboxAddress') },
    { key: 'folder', label: t('log.fields.folder') },
    { key: 'envelopeFrom', label: t('log.fields.envelopeFrom') },
  ];
  const present = fields.filter((field) => logItem?.[field.key]);

  if (present.length === 0) {
    return <SmartTooltip>{logItem?.message ?? ''}</SmartTooltip>;
  }

  return (
    <Stack gap="1x">
      {present.map((field) => (
        <Flex key={field.key} alignItems="baseline" columnGap="2x">
          <Text size="sm" color={colorStyle.color.secondary} minWidth="110px">
            {field.label}
          </Text>
          <Text size="sm" wordBreak="break-all">
            {logItem[field.key]}
          </Text>
        </Flex>
      ))}
    </Stack>
  );
};
